module.exports = __webpack_public_path__ + "static/media/logo-Loading-new.e41baff9.gif";